import type { EditControlProps } from '../../declare'
import { useMemo } from 'react'
import { Select } from 'antd'
import { $consts, $evt } from 'src/plugins'

const BatchEditControl = (props: EditControlProps) => {
  const handleSelectChange = (val: number) => {
    // 清空 val !== 2 disabled
    $evt.emit($consts['EVT/CONTROL_EDITABLE'], [props.config.FIELD_NAME], val !== 2)
    props.onChange?.(val)
  }
  const options = useMemo(() => {
    const { REQUIRED, CONTROL_TYPE } = props.config
    let preset = $consts['EDIT/BATCH_TEXTINPUT_UPDATES']
    switch (CONTROL_TYPE) {
      // 文本输入框
      case $consts['TABLE/CONTROL_TYPE_TEXTINPUT']:
        preset = preset.concat($consts['EDIT/BATCH_TEXTINPUT_OPERATES'])
        break
      // DATE 日期选择：精度到日
      case $consts['TABLE/CONTROL_TYPE_DATE_DAY']:
        preset = preset.concat($consts['EDIT/BATCH_DATE_DAYS'])
        break
    }
    !REQUIRED && (preset = preset.concat($consts['EDIT/BATCH_TEXTINPUT_CLEARS']))
    return preset
  }, [props.config])

  const { __READONLY__, EDITABLE, PROMPT_INFO } = props.config
  return (
    <Select
      disabled={__READONLY__ || !EDITABLE}
      options={options}
      value={props.value}
      onChange={handleSelectChange}
      placeholder={PROMPT_INFO}
    />
  )
}

export default BatchEditControl